export default __webpack_public_path__ + "12d418033209e7cef49e45c7ca7c0708.jpg";